import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-mouse-cursor-text{cursor:text}";
n(css,{});
export { css, css as default };
